// Updated interfaces to support multiple hierarchy levels
export interface Treatment {
    id: string;
    name: string;
    fee: string;
}

export interface CategoryBase {
    id: string;
    categoryId: string;
    name: string;
    level: number;
}

// A unified Category type that can have both subcategories and treatments
export interface ICategory extends CategoryBase {
    subCategories: ICategory[];
    treatments: any[];
    parentId: string | null;
    orderId: number;
}

export interface DragItem {
    type: string;
    id: string;
    index: number;
    parentId: string | null;
    treatmentId?: string; // For treatments
}

export const ItemTypes = {
    TREATMENT: "treatment",
    CATEGORY: "category", // Single category type for all levels
};

// Props for the recursive category component
export interface SortableCategoryItemProps {
    category: ICategory;
    index: number;
    parentId: string | null;
    moveCategory: (parentId: string | null, dragIndex: number, hoverIndex: number, dragCategoryId: number, hoverCategoryId: number) => void;
    moveItem: (
        dragIndex: number,
        hoverIndex: number,
        sourceCategoryId: string,
        targetCategoryId: string,
        dragTreatmentId: number,
        hoverTreatmentId: number
    ) => void;
    onDetailClick: (treatment: any) => void;
    setCategories: any;
    storeId: number;
    openAccordions: Array<string>;
    setOpenAccordions: React.Dispatch<React.SetStateAction<Array<string>>>;
}

export interface SortableTreatmentRowProps {
    id: string;
    treatment: any;
    index: number;
    categoryId: string;
    moveItem: (
        dragIndex: number,
        hoverIndex: number,
        sourceCategoryId: string,
        targetCategoryId: string,
        dragTreatmentId: number,
        hoverTreatmentId: number
    ) => void;
    onDetailClick: (treatment: any) => void;
}

export interface CategoryDroppableProps {
    id: string;
    children?: React.ReactNode;
}